import { render, staticRenderFns } from "./StorageContractRecord.vue?vue&type=template&id=237fdc1e&scoped=true"
import script from "./StorageContractRecord.vue?vue&type=script&lang=js"
export * from "./StorageContractRecord.vue?vue&type=script&lang=js"
import style0 from "./StorageContractRecord.vue?vue&type=style&index=0&id=237fdc1e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "237fdc1e",
  null
  
)

export default component.exports